// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PED_VEN_WORKFLOW_ST = {
  EmDigitacao: 'PED_VEN_WORKFLOW_ST1',
  EmAprovacao: 'PED_VEN_WORKFLOW_ST2',
  ReprovadoComercial: 'PED_VEN_WORKFLOW_ST3',
  AprovadoComercial: 'PED_VEN_WORKFLOW_ST4',
  Orcamento: 'PED_VEN_WORKFLOW_ST5',
  Confirmado: 'PED_VEN_WORKFLOW_ST6',
  EmAprovacaoDeCredito: 'PED_VEN_WORKFLOW_ST7',
  BloqueadoPorCredito: 'PED_VEN_WORKFLOW_ST8',
  AguardandoPagamento: 'PED_VEN_WORKFLOW_ST9',
  LiberadoParaExpedicao: 'PED_VEN_WORKFLOW_ST10',
  FaturadoParcial: 'PED_VEN_WORKFLOW_ST11',
  FaturadoTotal: 'PED_VEN_WORKFLOW_ST12',
  EncerradoParcialmente: 'PED_VEN_WORKFLOW_ST13',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PED_VEN_WORKFLOW_ST1: 1,
    PED_VEN_WORKFLOW_ST2: 2,
    PED_VEN_WORKFLOW_ST3: 3,
    PED_VEN_WORKFLOW_ST4: 4,
    PED_VEN_WORKFLOW_ST5: 5,
    PED_VEN_WORKFLOW_ST6: 6,
    PED_VEN_WORKFLOW_ST7: 7,
    PED_VEN_WORKFLOW_ST8: 8,
    PED_VEN_WORKFLOW_ST9: 9,
    PED_VEN_WORKFLOW_ST10: 10,
    PED_VEN_WORKFLOW_ST11: 11,
    PED_VEN_WORKFLOW_ST12: 12,
    PED_VEN_WORKFLOW_ST13: 13
  }
}
